import { connect } from 'react-redux'
import Attachment from './view'

export default connect(null, null)(Attachment)
